module.exports = __webpack_public_path__ + "static/media/icon_91.166fe032.svg";